import type { CostDict } from '../en/cost';

export const cost: CostDict = {
  menu: 'Kostnad',
  title: 'Kostnad',
  subtitle: (org: string) => `Vad ${org}s användning av Queri kostar den här månaden, i SEK.`,
  noAccess: 'Bara organisationens administratörer kan se kostnaderna.',
  loadFailed: 'Kunde inte hämta kostnaden',
  month: 'Månad',
  spent: 'Använt den här månaden',
  of: (ceiling: string) => `av taket på ${ceiling} per månad`,
  noCeiling: 'Inget månadstak överenskommet',
  percent: (p: string) => `${p} % av taket`,
  projected: (amount: string) => `I den här takten cirka ${amount} vid månadens slut`,
  overCeilingSoon: 'I den här takten slutar månaden över taket.',
  reached: 'Taket är nått. Queri fortsätter att fungera; vi kontaktar er innan något ändras.',
  alertNote: 'Administratörer får ett mejl vid 80 % och 100 % av taket.',
  daily: 'Per dag',
  byActivity: 'Per aktivitet',
  byPerson: 'Per person',
  activity: 'Aktivitet',
  person: 'Person',
  amount: 'Kostnad',
  share: 'Andel',
  nothingYet: 'Ingen användning den här månaden än.',
  previous: 'Tidigare månader',
  rateNote: (rate: string) => `Omräknat från AI-leverantörernas priser i USD med ${rate} kr per USD.`,
  unknownPerson: 'Bakgrundsjobb',
  categories: {
    review: 'Avtalsgranskning',
    drafting: 'Avtalsskrivning',
    questions: 'Frågor och chatt',
    wordAddIn: 'Word-tillägget',
    playbooks: 'Playbooks',
    email: 'E-postagenten',
    meetings: 'Möten',
    other: 'Sökning och övrigt',
  },
};
